import React, { CSSProperties, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import before1 from "../../../assets/equipments/before1.webp";
import before2 from "../../../assets/equipments/before2.webp";
import after1 from "../../../assets/work_completed/work-completed13.webp";
import after2 from "../../../assets/work_completed/work-completed12.webp";
import CustomButton from "../../common/CustomBtn";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Modal from "../../common/CustomModal";
import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const EquipmentRepairs = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  const equipmentImages = [
    {
      title: t("services.gallery_page_hill_climber"),
      before: before1,
      after: after1,
    },
    {
      title: t("services.gallery_page_playground_safe_coasting"),
      before: before2,
      after: after2,
    },
  ];

  const arrowStyles: CSSProperties = {
    position: "absolute",
    zIndex: 5,
    width: 30,
    height: 30,
    cursor: "pointer",
  };
  const settings = {
    beforeChange: (oldIndex: number, newIndex: number) =>
      setActiveSlide(newIndex),
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: (
      <button type="button" style={arrowStyles}>
        <div className="absolute p-2 text-white rounded-full left-2 ss:left-0 top-1/2 bg-primary md:-left-8">
          <ChevronLeftIcon />
        </div>
      </button>
    ),
    nextArrow: (
      <button type="button" style={arrowStyles}>
        <div className="absolute p-2 text-white rounded-full right-2 ss:right-0 md:-right-8 bg-primary top-1/2">
          <ChevronRightIcon />
        </div>
      </button>
    ),
  };

  return (
    <section className="w-full">
      <div className="maxContainer">
        <div className="max-w-[1024px] mx-auto py-12 ">
          <Slider {...settings} className="relative ">
            {equipmentImages.map((image, index) => (
              <div key={index} className="ss:p-5 bg-[#f4f4f4] w-full">
                <p className="font-semibold text-center my-2 ss:text-left text-[20px]">
                  {image.title}
                </p>
                <div className="flex justify-center mt-4 ss:gap-4">
                  <div
                    className="relative w-1/2 h-[239px] ss:h-[350px] cursor-pointer border overflow-hidden group"
                    onClick={() => setSelectedImage(image.before)}
                  >
                    <div
                      className="absolute inset-0 w-full transition-all duration-300 transform bg-center bg-cover group-hover:scale-105"
                      style={{ backgroundImage: `url(${image.before})` }}
                    ></div>
                    <div className="absolute inset-0 bg-black bg-opacity-50">
                      <div className="bg-primary absolute bottom-0 right-0 px-5 text-white text-[20px] font-semibold">
                        <h4>{t("services.gallery_page_before")}</h4>
                      </div>
                    </div>
                  </div>

                  {/* After Image */}
                  <div
                    className="relative w-1/2 h-[239px] ss:h-[350px] cursor-pointer border overflow-hidden group"
                    onClick={() => setSelectedImage(image.after)}
                  >
                    <div
                      className="absolute inset-0 transition-all duration-300 transform bg-center bg-cover group-hover:scale-105"
                      style={{ backgroundImage: `url(${image.after})` }}
                    ></div>
                    <div className="absolute inset-0 bg-black/20">
                      <div className="bg-primary absolute top-0 left-0 px-5 text-white text-[20px] font-semibold">
                        <h4>{t("services.gallery_page_after")}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>

          <div className="flex flex-col items-center">
            <div className="relative w-1/2 h-2 mt-4 overflow-hidden bg-gray-300 rounded-full">
              <div
                className="h-full transition-all duration-300 rounded-full"
                style={{
                  width: `${((activeSlide + 1) / equipmentImages.length) * 100}%`,
                  background: "linear-gradient(90deg, #2e7fc3, #75b129)",
                }}
              ></div>
            </div>
          </div>
        </div>

        <div className="flex justify-center mt-4">
          <CustomButton
            variant="outlined"
            color="primary"
            onClick={() => navigate("/e-shop/spare-parts")}
          >
            {t("services.gallery_page_spare_parts_button")}
          </CustomButton>
        </div>
      </div>

      {/* Modal */}
      <Modal
        isOpen={!!selectedImage}
        onClose={() => setSelectedImage(null)}
        size="max-content"
      >
        <img
          src={selectedImage!}
          className="object-contain max-h-[80vh] w-auto max-w-full"
          alt="equipment-repair"
        />
      </Modal>
    </section>
  );
};

export default EquipmentRepairs;
